import type { GameMeta } from '@gmp/game-sdk';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const misquotedMeta = {
  id: 'misquoted',
  name: 'Misquoted!',
  tagline: 'Which movie says this EXACT line? Or is it a fake?',
  description:
    'A live movie-quote showdown. Everyone gets the same line and the same seconds: name the film, or call out a misquote. Faster right answers score more.',
  minPlayers: 2,
  maxPlayers: 12,
  estimatedMinutes: [5, 10],
  usesMedia: false,
  modes: [
    { id: 'beginner', name: 'Beginner', description: 'Real, exact quotes. Pick the movie from four.' },
    { id: 'medium', name: 'Medium', description: 'Mostly real quotes, some invented ones: four movies or “Not an actual movie quote”.' },
    { id: 'hard', name: 'Hard', description: 'Real lines, near-misses and famous misquotes. Only the exact wording counts.' },
  ],
  theme: { primary: '#f5c518', secondary: '#e8443a', background: '#120d0b', ink: '#fff4d6' },
  readiness: 'beta',
  genre: 'Live movie-quote trivia',
  controls: 'tap',
  category: 'party',
  instructions: [
    { icon: 'Quote', title: 'Read the line', body: 'Everyone sees the same line at the same moment, with about half a minute on the clock.' },
    { icon: 'Film', title: 'Which movie says it EXACTLY?', body: 'Pick the film that says this exact line. On Medium and Hard you can also pick “Not an actual movie quote”.' },
    { icon: 'Ban', title: 'Misquotes are fakes', body: 'On Hard, a famous line with even one word changed is “Not an actual movie quote”, even if you know the film it imitates.' },
    { icon: 'Timer', title: 'Fast and right wins', body: 'Correct = 500 + up to 500 speed bonus (from when the server got your answer). Wrong or no answer = 0. Your first tap is final.' },
    { icon: 'Trophy', title: 'Ties', body: 'Ties are broken by most correct answers, then by the fastest total time on correct answers.' },
  ],
} satisfies GameMeta;
